import {
  Plan,
  PlanInfo,
  SubscriptionGetDetailedResponse,
} from "@jugl-web/rest-api";

interface GetCurrentCxPlanParams {
  subscription: SubscriptionGetDetailedResponse | undefined;
  plans: Plan[] | undefined;
}

export interface CurrentCxPlanResult {
  currentPlan: Plan | undefined;
  currentPlanId: string | undefined;
}

/**
 * Resolves the current CX plan from a detailed subscription response and plans list.
 */
export const getCurrentCxPlan = ({
  subscription,
  plans,
}: GetCurrentCxPlanParams): CurrentCxPlanResult => {
  const planLineItem = subscription?.details?.plan?.line_items?.find(
    (item) => item.info.kind === "plan"
  );

  const currentPlanId =
    planLineItem?.info.kind === "plan"
      ? (planLineItem.info as PlanInfo).plan_id
      : undefined;

  const currentPlan =
    currentPlanId && plans
      ? plans.find((plan) => plan.id === currentPlanId)
      : undefined;

  return { currentPlan, currentPlanId };
};
